module.exports = __webpack_public_path__ + "img/CV-TEAM.88fa09eb.svg";